import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Templates from './pages/Templates';
import WorkflowBuilder from './pages/WorkflowBuilder';
import Executions from './pages/Executions';
import './styles/index.css';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className="flex flex-1">
          <Sidebar />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/builder" element={<WorkflowBuilder />} />
            <Route path="/executions" element={<Executions />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
